import { UntypedFormControl } from '@angular/forms';

export class AppDefinedField {
    public formControl: UntypedFormControl;
}
